import { cumulativeLineConfig } from '../../chart/TrendLine';

// Расчет накопительной суммы, к каждому значению по оси Y прибавляется сумма всех предыдущих значений Y
export const calculateCumulative = (data) =>
  data.reduce(
    (res, { x, y }) => (res.length ? [...res, { x, y: y + res.at(-1).y }] : [{ x, y }]),
    []
  );

export const showCumulative = (chart, yMax) => {
  const { userOptions } = chart;
  userOptions.cumulativeShow = true;
  chart.yAxis[0].update({ max: Math.max(yMax, chart.yAxis[0].dataMax) });
};

export const hideCumulative = (chart) => {
  const { userOptions } = chart;
  userOptions.cumulativeShow = false;
  chart.yAxis[0].update({ max: chart.yAxis[0].dataMax });
};

// Рендер линии накопительной суммы
export const renderCumulativePaths = (chart, cumulativeLines, strokeColor) => {
  const xAxis = chart.xAxis[0];
  const yAxis = chart.yAxis[0];

  return chart.renderer
    .path(['M', ...cumulativeLines.map((v) => [xAxis.toPixels(v.x), yAxis.toPixels(v.y)])])
    .attr({
      ...cumulativeLineConfig,
      zIndex: 5,
      stroke: strokeColor,
    })
    .add();
};
